import { breadcrumbConfig } from '../breadcrumb-config';
import { findDynamicRouteMatch } from './find-dynamic-route-match';
import { generateDefaultLabelFromSegment } from './generate-default-label-from-segment';

export function resolveBreadcrumbLabel(currentPath: string, segment: string): string {
  return (
    breadcrumbConfig[currentPath] ||
    findDynamicRouteMatch(currentPath) ||
    generateDefaultLabelFromSegment(segment)
  );
}
